import { apiHolder } from 'api';
import { useObservable } from 'rxjs-hooks';
import { of } from 'rxjs';
import { useEffect } from 'react';
const nimApi = apiHolder.api.requireLogicalApi('NIM');
export function useImTeam(teamId, isForceUpdate = false) {
    useEffect(() => {
        nimApi.imteamStream.requestTeamById(teamId, isForceUpdate);
    }, []);
    return useObservable(() => nimApi.imteamStream.getTeamById(of(teamId)), undefined, [teamId]);
}
export function useImTeamType(teamId, scene = 'team') {
    useEffect(() => {
        nimApi.imteamStream.requestTeamById(teamId);
    }, []);
    const teamInfo = useObservable(() => nimApi.imteamStream.getTeamById(of(teamId)), undefined, [teamId]);
    let teamType = 'normal';
    try {
        teamType = JSON.parse((teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.serverCustom) || '{}').eteam ? 'discuss' : 'normal';
    }
    catch (e) { }
    return teamType;
}
export function useIMTeamField(teamId, field = 'teamId') {
    return useObservable((_, $props) => nimApi.imteamStream.getTeamField($props), '', [teamId, field]);
}
